import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/styles/fonts.css' // 引入字体配置文件
import '@/styles/element-ui-fonts.css' // 引入Element UI字体配置
import '@/styles/common.css'
import {i18n} from './i18n/index.js';
import { message } from './utils/resetMessage';
import{ debounce, formatDate, getLabelByValue,numberToChinese } from '@/utils/common.js'
import { filters } from '@/utils/filters.js'
import Vant from 'vant';
import 'vant/lib/index.css';
import NavBar from "@/components/student/navBar.vue"
import * as echarts from 'echarts'
import VMdPreview from '@kangc/v-md-editor/lib/preview';
import '@kangc/v-md-editor/lib/style/preview.css';
import VueMarkdownEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import vuepressTheme from '@kangc/v-md-editor/lib/theme/vuepress.js';
import '@kangc/v-md-editor/lib/theme/style/vuepress.css';
import createKatexPlugin from '@kangc/v-md-editor/lib/plugins/katex/cdn';

import Prism from 'prismjs';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';

// highlightjs
import hljs from 'highlight.js';
import dragDialog from '@/utils/dragDialog.js'
import { oemConfigMethods } from '@/utils/oemConfig.js'
import imagePreviewDirective from '@/utils/imagePreviewDirective.js'

Vue.directive('drag-dialog', dragDialog)
Vue.directive('image-preview', imagePreviewDirective)
VMdPreview.use(githubTheme, {
  Hljs: hljs,
});

VueMarkdownEditor.use(vuepressTheme, {
  Prism,
});
VueMarkdownEditor.use(createKatexPlugin());

Vue.component('NavBar', NavBar);
Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(VueMarkdownEditor);
Vue.use(VMdPreview);

// 全局 oemConfig 管理 - 从 oemConfig.js 导入
Vue.prototype.$getOemConfig = oemConfigMethods.getOemConfig;
Vue.prototype.$setOemConfig = oemConfigMethods.setOemConfig;
Vue.prototype.$watchOemConfig = oemConfigMethods.watchOemConfig;
Vue.prototype.$smartGetOemConfig = oemConfigMethods.smartGetOemConfig;

// 安全清除 localStorage 方法
Vue.prototype.$safeClearLocalStorage = oemConfigMethods.safeClearLocalStorage;
Vue.prototype.$clearLocalStorageExceptOemConfig = oemConfigMethods.clearLocalStorageExceptOemConfig;
Vue.prototype.$clearLocalStorageExcluding = oemConfigMethods.clearLocalStorageExcluding;

Vue.prototype.$debounce = debounce
Vue.prototype.$formatDate = formatDate
Vue.prototype.$getLabelByValue = getLabelByValue
Vue.prototype.$numberToChinese = numberToChinese
Vue.prototype.$message = message
Vue.prototype.$echarts = echarts

// // 错误捕获
// Vue.config.errorHandler = function (err, vm, info) {
//   console.error('全局捕获 err >>>', err)
//   console.error('全局捕获 vm >>>', vm)
//   console.error('全局捕获 info >>>', info)
// }

// 定义全局自定义过滤器
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
